import React from "react";

export default function UxbiSpinner({
  size,
  label = "Cargando…",
  className = "",
}) {
  return (
    <span
      className={`uxbi-loader ${size === "sm" ? "uxbi-loader-small" : ""} ${className}`}
      role="status"
      aria-label={label}
    >
      <img src="/uxbi-loading.png" alt="" aria-hidden="true" />
    </span>
  );
}

export function SelectLoadingIndicator() {
  return <UxbiSpinner size="sm" />;
}
